<!------------------------------

      Page Actions

------------------------------->


<ng-container *sbPageAction>
  <button
    *ngPermissions="[permissionService.Permission.product_create]"
    sb-button-primary
    type="button"
    color="green"
    icon="plus"
    [disabled]="loading()"
    [iconButton]="true"
    sbTooltip="{{ 'lang.globals.product.create' | translate }}" container="body"
    [queryParams]="{returnTo: util.getPageLink()}"
    [sbRouterLink]="util.RoutingID.productCreate">
  </button>
  <button
    type="button"
    sb-button-primary
    icon="refresh"
    [iconButton]="true"
    [color]="'blue'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" container="body"
    placement="top">
  </button>
  <button
    sb-button-primary
    type="button"
    [color]="'blue'"
    [disabled]="loading()"
    [sbTooltip]="'lang.globals.columnOptions' | translate"
    (click)="openColumnOptionModal(applyColumns.bind(this))"
    [iconButton]="true"
    [icon]="'columns'"
  >
  </button>
  <button
    *ngPermissions="[permissionService.Permission.product_category_list]"
    sb-button-primary
    type="button"
    color="blue"
    icon="productCategory"
    [disabled]="loading()"
    [iconButton]="true"
    sbTooltip="{{ 'lang.products.manageCategories' | translate }}" container="body"
    [queryParams]="{returnTo: util.getPageLink()}"
    [sbRouterLink]="util.RoutingID.productCategories">
  </button>

</ng-container>


<!------------------------------

    Table wrapper

------------------------------->

@let isExpanded = checkExpansion();
<sb-table-wrapper-new
  headline="{{'lang.globals.products' | translate}}"
  [itemsData]="productsList()"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'products'"
  [isFilterPanelOpen]="isExpanded"
  class="tw-w-full"
  [isMultiSelectEnabled]="selectedProducts()?.size > 0"
  [isInModalContext]="isInModalContext">
  <!------------------------------

   Filter

------------------------------->
  <div filter-panel class="dark:tw-bg-sbGray-930 tw-bg-[#F8F9FC] tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >
      <sb-filter-section *ngPermissions="permissionService.Permission.company_list" title="{{'lang.globals.companies' | translate}}"
                         icon="company">
        <sb-filter-dto-list-select filterID="company" [isSingleSelect]="true" [endpoint]="api.shared_Company_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>
      <sb-filter-section *ngPermissions="permissionService.Permission.product_category_list"
                         title="{{'lang.globals.productCategory' | translate}}"
                         icon="clock">
        <sb-filter-dto-list-select filterID="productCategories" [endpoint]="api.pm_ProductCategory_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>

      <div class="tw-mx-3 tw-gap-2.5 tw-flex tw-flex-col">
        <div
          #filterPanelOrder
          class="tw-flex tw-flex-row tw-font-semibold tw-items-center tw-duration-500 tw-transition-all tw-ease-in-out tw-group tw-w-fit"
          [ngClass]="{'tw-cursor-pointer': !isExpanded}"
          (click)="!isExpanded?openFilterPanel(filterPanelOrder):scrollToFilterPanelElement(filterPanelOrder)">
          <sb-icon class="tw-text-xl tw-transition-all tw-duration-500" [ngClass]="{'tw-ml-2.5': !isExpanded}"
                   icon="sort"></sb-icon>
          <div class="tw-duration-500 tw-transition-all tw-ease-in-out tw-origin-left tw-text-lg tw-flex-1"
               [ngClass]="{
      'tw-opacity-0 tw-w-0': !isExpanded,
      'tw-opacity-100 tw-w-full tw-ml-2.5': isExpanded,
    }">{{ 'lang.globals.order' | translate }}
          </div>
        </div>
        <div class="tw-flex tw-gap-2.5">

          @let fpOrderOption = filterPanelOrderOption();
          <sb-button-dropdown
            [selectedValue]="fpOrderOption.value" [items]="allOrderOptions|omit: 'direction'"
            (outputChange)="setToOrderFilterPanel(filterPanelOrderOption, $event)"
            [openDirection]="'Up'"
            class="tw-duration-500 tw-origin-left tw-transition-all tw-ease-in-out tw-origin-left"
            [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
          >
          </sb-button-dropdown>
          <sb-segment-control
            [ngClass]="{
            'tw-opacity-0 tw-w-0 tw-hidden': !isExpanded,
            'tw-opacity-100 tw-flex': isExpanded,
          }"
            [selectedOption]="{value: fpOrderOption.direction}"
            [options]="[{value: 'asc', icon: 'sortUpFilled' },{value: 'desc', icon: 'sortDownFilled' }]"
            (selectedOptionChange)="setOrderDirectionFilterPanel(filterPanelOrderOption, $event.value)"
          ></sb-segment-control>
        </div>
      </div>
    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    @let currentOrderOption = orderOption();
    <tr #tableHead class="noselect" cdkDropList cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="dropListDropped($event, applyColumns.bind(this))">
      @if (isInModalContext) {
        <th
          class="sticky-col last-col">
          <sb-comp-table-multi-select-button [selectionState]="selectionState()"
                                             (action)="selectAction($event)"></sb-comp-table-multi-select-button>
        </th>
      }
      <th *ngPermissions="[permissionService.Permission.tag_list]">Tags
      </th>
      @for (column of selectedColumns; track column.id; let i = $index) {
        <th (cdkDragStarted)="dragStarted($event, i)" [cdkDragData]="column" [cdkDragDisabled]="window.scrollY > 0"
            cdkDrag class="stickyHeaderViewChild" nowrap>
          <div class="tw-flex tw-items-center tw-gap-2">
            @let isColSortingAllowed = isSortingAllowed(column);
            @let isColFilteringAllowed = isFilteringAllowed(column);
            @if (isColSortingAllowed) {
              <div (click)="setToOrderAndRefresh(column)" class="cursor-pointer d-inline-flex *:tw-ml-2 hover:tw-text-sbBlue-500"
                   [ngClass]="{'tw-text-sbBlue-500': currentOrderOption?.value?.id===column?.id}">
                {{ (column.title ?? column.id) |translate }}
                @if (currentOrderOption.value?.id === column?.id) {
                  @if (currentOrderOption.direction === 'desc') {
                    <sb-icon icon="sortDownFilled"></sb-icon>
                  } @else {
                    <sb-icon icon="sortUpFilled"></sb-icon>
                  }
                } @else {
                  <sb-icon icon="sort"></sb-icon>
                }
              </div>
            } @else {
              <div class="">
                {{ (column.title ?? column.id) |translate }}
              </div>
            }
            @if (isColSortingAllowed && isColFilteringAllowed) {
              <div class="vertical-spacer"></div>
            }
            @if (isColFilteringAllowed) {
              <div
                (click)="columnFilter(column, 'locationFilter')"
                [ngClass]="{'tw-text-sbBlue-500': isFilterClassActive(column), 'tw-animate-ping-bg': !loading() && columnFiltersMap.has(column.id)}"
                class="cursor-pointer tw-flex tw-items-center hover:tw-text-sbBlue-500">
                @if (isFilterClassActive(column)) {
                  <sb-icon [icon]="'funnelFilled'"></sb-icon>
                } @else {
                  <sb-icon [icon]="'funnel'"></sb-icon>

                }
              </div>
              @if (column.type !== 'PROPERTY') {
                <div class="vertical-spacer"></div>
                <sb-icon [icon]="getColumnIcon(column)" [ngbTooltip]="getColumnTypeTitle(column)"
                         class="cursor-help" container="body">
                </sb-icon>
              }
            }
          </div>
          <div *cdkDragPreview class="drag-placeholder dark:tw-text-white">
            {{ (column.title ?? column.id) |translate }}
          </div>
        </th>
      }
      @if (!isInModalContext) {
        <th class="sticky-col last-col tw-z-20">
          {{ 'lang.globals.action' |translate }}
        </th>
      }
    </tr>
  </ng-template>

  <ng-template #tCardHead>
    @let currentOrderOption = orderOption();
    <tr (cdkDropListDropped)="dropListDropped($event, applyColumns.bind(this))" cdkDropList cdkDropListOrientation="horizontal"
        class="noselect">
      @if (isInModalContext) {
        <th>
          <sb-comp-table-multi-select-button [selectionState]="selectionState()"
                                             (action)="selectAction($event)"></sb-comp-table-multi-select-button>
        </th>
      }
      <th *ngPermissions="[permissionService.Permission.tag_list]">
        Tags
      </th>
      @for (column of selectedColumns; track column.id; let i = $index) {
        @let isColSortingAllowed = isSortingAllowed(column);
        @let isColFilteringAllowed = isFilteringAllowed(column);
        @if (isColSortingAllowed || isColFilteringAllowed) {
          <th (cdkDragStarted)="dragStarted($event, i)" [cdkDragData]="column" [cdkDragDisabled]="window.scrollY > 0"
              cdkDrag class="stickyHeaderViewChild" nowrap>
            <div class="tw-flex tw-items-center tw-gap-2">
              @if (isColSortingAllowed) {
                <div (click)="setToOrderAndRefresh(column)" class="cursor-pointer d-inline-flex *:tw-ml-2 hover:tw-text-sbBlue-500"
                     [ngClass]="{'tw-text-sbBlue-500': currentOrderOption?.value?.id===column?.id}">
                  {{ (column.title ?? column.id) |translate }}
                  @if (currentOrderOption.value?.id === column?.id) {
                    @if (currentOrderOption.direction === 'desc') {
                      <sb-icon icon="sortDownFilled"></sb-icon>
                    } @else {
                      <sb-icon icon="sortUpFilled"></sb-icon>
                    }
                  } @else {
                    <sb-icon icon="sort"></sb-icon>
                  }
                </div>
              } @else {
                <div class="">
                  {{ (column.title ?? column.id) |translate }}
                </div>
              }
              @if (isColSortingAllowed && isColFilteringAllowed) {
                <div class="vertical-spacer"></div>
              }
              @if (isColFilteringAllowed) {
                <div
                  (click)="columnFilter(column, 'locationFilter')"
                  [ngClass]="{'tw-text-sbBlue-500': isFilterClassActive(column), 'tw-animate-ping-bg': !loading() && columnFiltersMap.has(column.id)}"
                  class="cursor-pointer tw-flex tw-items-center hover:tw-text-sbBlue-500">
                  @if (isFilterClassActive(column)) {
                    <sb-icon [icon]="'funnelFilled'"></sb-icon>
                  } @else {
                    <sb-icon [icon]="'funnel'"></sb-icon>

                  }
                </div>
                @if (column.type !== 'PROPERTY') {
                  <div class="vertical-spacer"></div>
                  <sb-icon [icon]="getColumnIcon(column)" [ngbTooltip]="getColumnTypeTitle(column)"
                           class="cursor-help" container="body">
                  </sb-icon>
                }
              }
            </div>
            <div *cdkDragPreview class="drag-placeholder dark:tw-text-white">
              {{ (column.title ?? column.id) |translate }}
            </div>
          </th>
        }
      }
      <th class="!tw-w-auto"><!-- empty header for minimal header with on the others --></th>
    </tr>
  </ng-template>
  <!------------------------------

   SelectionMode

------------------------------->
  <ng-template #tSelectionMode>
    <sb-action-bar [isInModalContext]="isInModalContext">
      <!-- projected info -->
      <div info>
        {{ selectedProducts().size }} {{ 'lang.globals.selected' | translate }}
      </div>

      <!-- deselect button -->
      <button
        deselect
        type="button"
        sb-button-secondary
        [color]="'blue'"
        class="tw-text-nowrap"
        (click)="selectAction('deselectAll')">
        {{ 'lang.multiSelect.deselectAll'|translate }}
      </button>
      <!--  actions -->
      <button
        modalActions
        type="button"
        sb-button-primary
        [color]="'blue'"
        class="tw-text-nowrap"
        (click)="returnSelectedProducts()">
        {{ 'lang.globals.save' | translate }}
      </button>

    </sb-action-bar>
  </ng-template>
  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-product>
    <tr [style.height.px]="70">
      @if (isInModalContext) {
        <td class="sticky-col first-col">
          @let isItemSelected = selectedProducts().has(product?.id) ?? false;
          <sb-comp-table-select-button [isSelected]="isItemSelected" (action)="selectProduct(product)"></sb-comp-table-select-button>
        </td>
      }
      <td *ngPermissions="[permissionService.Permission.tag_list]">
        <sb-tags [tags]="product.tags"
                 [dtoType]="tagService.TaggableDTO.Product" [dtoId]="product?.id"></sb-tags>
      </td>

      @for (col of selectedColumns; track col.id) {
        @let column = createTableCell(col, 'Product', product);
        <td>
          <sb-comp-dynamic-table-element [displayColumn]="column"
                                         [isInIntegratedContext]="isInIntegratedContext"></sb-comp-dynamic-table-element>
        </td>
      }
      @if (!isInModalContext) {
        <td class="sticky-col last-col tr">
          <div>
            <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: product}"></ng-container>
          </div>
        </td>
      }
    </tr>
  </ng-template>

  <!------------------------------

    Card element


    -------------------------------->

  <ng-template #card let-product>
    <sb-table-card [classes]="'hover:tw-bg-sbGrayBlue-100 '">
      <div table-card-header>
        @if (isInModalContext) {
          @let isProductSelected = selectedProducts().has(product?.id) ?? false;
          <sb-comp-table-select-button [isSelected]="isProductSelected" (action)="selectProduct(product)"></sb-comp-table-select-button>
        }
      </div>

      @if (!isInModalContext) {
        <div table-card-header-more>
          <ng-container [ngTemplateOutlet]="ActionButtons" [ngTemplateOutletContext]="{$implicit: product}"></ng-container>
        </div>
      }
      <div table-card-img>
        @if (product.depiction) {
          <div
            [style.background-image]="'url('+ product.depiction.url + ')'"
            class="tw-bg-[url(assets/img/no-image.png)] tw-bg-cover tw-bg-center tw-h-full">
          </div>
        } @else {
          <div class="tw-bg-[url(assets/img/no-image.png)] tw-bg-cover tw-bg-center tw-h-full">
          </div>
        }

      </div>
      <div table-card-body>
        <div
          class="sm:tw-grid sm:tw-grid-cols-4 tw-flex tw-flex-col tw-text-sbGray-800 *:sm:tw-col-span-2 *:tw-w-full *:tw-border-0 *:tw-border-b *:tw-border-solid *:tw-border-sbGray-200 *:sm:tw-py-5 *:tw-py-3.5">

          <sb-table-card-element class="!tw-col-span-4" [headline]="'Tags'" [orientation]="'left'">
            <sb-tags [dtoId]="product.id" [dtoType]="tagService.TaggableDTO.Product"
                     [tags]="product.tags"></sb-tags>
          </sb-table-card-element>
          @for (col of selectedColumns; track col.id; let odd = $odd; let last = $last; let index = $index; let count = $count) {
            @let column = createTableCell(col, 'Product', product);
            @let isEvenColumns = (selectedColumns?.length % 2) === 0;
            <sb-table-card-element
              [headline]="column.title ?? column.id | translate"
              [ngClass]="{'!tw-border-0': last || (isEvenColumns && ((selectedColumns?.length - 2) === index)) }"
              [orientation]="odd ? 'right' : 'left'">
              <sb-comp-dynamic-table-element [displayColumn]="column"
                                             [isInIntegratedContext]="isInIntegratedContext"></sb-comp-dynamic-table-element>
            </sb-table-card-element>
          }
        </div>
      </div>
    </sb-table-card>
  </ng-template>

</sb-table-wrapper-new>


<ng-template #ActionButtons let-product>
  @if (!isInModalContext) {
    <sb-split-button
      [splitButtonItems]="product?.sbButtons ?? []"
    ></sb-split-button>
  }

</ng-template>
